import { render, staticRenderFns } from "./user-menu.vue?vue&type=template&id=7635770f&scoped=true"
import script from "./user-menu.vue?vue&type=script&lang=js"
export * from "./user-menu.vue?vue&type=script&lang=js"
import style0 from "./user-menu.vue?vue&type=style&index=0&id=7635770f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7635770f",
  null
  
)

export default component.exports